document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Mobile nav ---------- */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      mobileNav.classList.toggle('active');
    });
  }

  /* ---------- Search toggle ---------- */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchPanel = document.querySelector('[data-search-panel]');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      searchPanel.classList.toggle('active');
      if (searchPanel.classList.contains('active')) {
        var input = searchPanel.querySelector('input');
        if (input) input.focus();
      }
    });
  }

  /* ---------- Money: always show Pakistani Rupees ---------- */
  function formatMoney(cents) {
    return 'Rs ' + (Number(cents || 0) / 100).toLocaleString('en-PK', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  /* ---------- Cart drawer ---------- */
  var cartDrawer = document.getElementById('CartDrawer');
  var cartOverlay = document.getElementById('CartDrawerOverlay');
  var cartToggle = document.querySelector('[data-cart-toggle]');
  var cartClose = cartDrawer ? cartDrawer.querySelector('.cart-drawer__close') : null;

  function openCart() {
    if (!cartDrawer) return;
    renderCartDrawer();
    cartDrawer.classList.add('active');
    cartDrawer.setAttribute('aria-hidden', 'false');
    if (cartOverlay) cartOverlay.classList.add('active');
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('active');
    cartDrawer.setAttribute('aria-hidden', 'true');
    if (cartOverlay) cartOverlay.classList.remove('active');
  }

  if (cartToggle) cartToggle.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function renderCartDrawer() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var itemsEl = document.getElementById('CartDrawerItems');
        var subtotalEl = document.getElementById('CartDrawerSubtotal');
        updateCartCount(cart.item_count);
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

        if (!itemsEl) return;
        if (cart.items.length === 0) {
          itemsEl.innerHTML = '<p>Your bag is empty.</p>';
          return;
        }

        itemsEl.innerHTML = cart.items.map(function (item) {
          var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
          return (
            '<div class="cart-drawer__item" data-cart-item-key="' + escapeHtml(item.key) + '">' +
              (item.image ? '<img src="' + escapeHtml(item.image) + '" alt="" class="cart-drawer__item-image">' : '') +
              '<div class="cart-drawer__item-info">' +
                '<p class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</p>' +
                (variant ? '<p class="cart-drawer__item-variant">' + escapeHtml(variant) + '</p>' : '') +
                '<p class="cart-drawer__item-meta">Qty ' + item.quantity + '</p>' +
                '<p class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</p>' +
                '<button type="button" class="cart-remove" data-cart-remove="' + escapeHtml(item.key) + '">Remove</button>' +
              '</div>' +
            '</div>'
          );
        }).join('');

        itemsEl.querySelectorAll('[data-cart-remove]').forEach(function (button) {
          button.addEventListener('click', function () {
            var key = button.getAttribute('data-cart-remove');
            button.disabled = true;
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: key, quantity: 0 })
            })
              .then(function (res) { return res.json(); })
              .then(function () { renderCartDrawer(); })
              .catch(function () { button.disabled = false; });
          });
        });
      })
      .catch(function (err) { console.error('Cart fetch failed', err); });
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  /* ---------- Add to cart (AJAX) ---------- */
  var productForm = document.getElementById('ProductForm');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(productForm);
      var submitBtn = productForm.querySelector('[data-add-to-cart]');
      var originalText = submitBtn ? submitBtn.textContent.trim() : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding...';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (data) { throw new Error(data.description || 'Unable to add to cart'); });
          return res.json();
        })
        .then(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
          }
          openCart();
        })
        .catch(function (err) {
          console.error('Add to cart failed', err);
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalText || 'Add to Bag';
          }
        });
    });
  }

  /* ---------- Product variants ---------- */
  if (productForm) {
    var variantInput = productForm.querySelector('[data-variant-id]');
    var variantJson = productForm.querySelector('[data-product-variants]');
    var priceEl = document.querySelector('.product__price');
    var addButton = productForm.querySelector('[data-add-to-cart]');
    var variants = [];

    if (variantJson) {
      try { variants = JSON.parse(variantJson.textContent); } catch (e) { variants = []; }
    }

    function getSelectedOptions() {
      return Array.from(productForm.querySelectorAll('.product__swatches')).map(function (group) {
        var active = group.querySelector('.swatch.active');
        return active ? active.getAttribute('data-option-value') : null;
      });
    }

    function findVariant() {
      var selected = getSelectedOptions();
      return variants.find(function (variant) {
        return variant.options.every(function (option, index) {
          return !selected[index] || option === selected[index];
        });
      });
    }

    function updateVariant() {
      var variant = findVariant();
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? 'Add to Bag' : 'Sold Out';
      }
      if (priceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceEl.innerHTML = '<span class="price price--sale">' + formatMoney(variant.price) + '</span>' +
            '<span class="price price--compare">' + formatMoney(variant.compare_at_price) + '</span>';
        } else {
          priceEl.innerHTML = '<span class="price">' + formatMoney(variant.price) + '</span>';
        }
      }
    }

    productForm.querySelectorAll('.product__swatches').forEach(function (group) {
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('.swatch');
        if (!btn) return;
        group.querySelectorAll('.swatch').forEach(function (s) { s.classList.remove('active'); });
        btn.classList.add('active');
        updateVariant();
      });
    });
    updateVariant();
  }

  /* ---------- Product media thumbnails ---------- */
  document.querySelectorAll('[data-media-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var id = thumb.getAttribute('data-media-thumb');
      document.querySelectorAll('.product__media-item').forEach(function (item) {
        item.classList.toggle('active', item.getAttribute('data-media-id') === id);
      });
      document.querySelectorAll('.product__media-thumb').forEach(function (t) {
        t.classList.toggle('active', t === thumb);
      });
    });
  });

});
